export default {
  API: {
    // baseURL: "https://yuval-projects-app.herokuapp.com/api"
    baseURL: "https://app.vame.io/api"
  }
};
